import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';

interface ExcluirPedidoDialogProps {
  open: boolean;
  loading: boolean;
  onClose: () => void;
  onConfirm: () => void;
  /**
   * true quando o pedido ja foi finalizado (e ainda nao sincronizado com o ERP).
   * AIDEV-NOTE: muda o texto e acrescenta o aviso sobre sincronizacao parcial.
   */
  pedidoFinalizado?: boolean;
}

// AIDEV-NOTE: Confirmacao de exclusao de pedido — compartilhada entre lista e detalhe.
// Atende rascunho e tambem finalizado/erro_sync ainda nao sincronizados (ver podeExcluirPedido).
export function ExcluirPedidoDialog({
  open,
  loading,
  onClose,
  onConfirm,
  pedidoFinalizado = false
}: ExcluirPedidoDialogProps) {
  return (
    <Dialog open={open} onClose={loading ? undefined : onClose}>
      <DialogTitle>{pedidoFinalizado ? 'Excluir pedido?' : 'Excluir rascunho?'}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {pedidoFinalizado
            ? 'O pedido será excluído permanentemente. Esta ação não pode ser desfeita.'
            : 'O rascunho será excluído permanentemente. Esta ação não pode ser desfeita.'}
        </DialogContentText>
        {/* AIDEV-NOTE: O DELETE limpa apenas Postgres/Dexie — o app nao apaga nada no Firebird
            (usuario de sync tem SELECT/INSERT/UPDATE, sem DELETE). Se o pedido tiver entrado no
            ERP numa sincronizacao parcial, a baixa la e manual. */}
        {pedidoFinalizado && (
          <Alert severity="warning" sx={{ mt: 2 }}>
            Este pedido ainda não foi sincronizado com o ERP. A exclusão remove o pedido apenas do
            aplicativo — se ele já tiver entrado no ERP, a baixa lá precisa ser feita manualmente.
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancelar
        </Button>
        <Button
          color="error"
          variant="contained"
          onClick={onConfirm}
          disabled={loading}
          startIcon={loading ? <CircularProgress size={16} color="inherit" /> : undefined}
        >
          Excluir
        </Button>
      </DialogActions>
    </Dialog>
  );
}
